import "core-js/stable";
import "regenerator-runtime/runtime";
import React from 'react';
import { render } from 'react-dom';
import Root from './components/Root';
import { history, store } from './redux/stores/configureStore';
import * as serviceWorker from './serviceWorker';
 import 'antd/dist/antd.css';
import './styles/ltr/layout.scss'
performance.mark("APP_START");
if ("PerformanceObserver" in window) {
  const lcpObserver = new PerformanceObserver((entryList) => {
    const entries = entryList.getEntries();
    const lastEntry = entries[entries.length - 1];

    console.log("!LCP ENTRY", {
      time: lastEntry.startTime,
      size: lastEntry.size,
      url: lastEntry.url,
      element: lastEntry.element,
      tagName: lastEntry.element?.tagName,
      className: lastEntry.element?.className,
      id: lastEntry.element?.id,
      text: lastEntry.element?.textContent?.slice(0, 100),
    });
  });

  lcpObserver.observe({
    type: "largest-contentful-paint",
    buffered: true,
  });
}
render(
    <Root store={store} history={history} />,
    document.getElementById('root')
);


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
